// linted by Ricky Kim

import React from 'react';
import '../App.css';
import BarcodeAttendance from './BarcodeAttendance';
import Review from './Review';
import DefermentMessage from './DefermentMessage';
import ErrorMessage from './ErrorMessage';
import Notifications from '../notifications/Notifications';
import { apiService } from '../Services/summonsAPI';
import KioskOutcome from '../Components/KioskOutcome';

export default class CheckIn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            affidavitLink: null
        };
    }

    async componentDidMount() {
        const affidavitLink = await apiService.getAffidavitLink().then((response) => response.text());
        this.setState({
            affidavitLink: affidavitLink
        });
    }

    render() {
        /* herring */
        if (this.props.kioskMode) return <KioskOutcome jurorStatus={this.props.jurorStatus} />;

        /* Depend on status, display appropriate messge:
        1 - questionnaireIncomplete
        2 - questionnaireComplete
        3 - possibleDeferment
        4 - deferred
        */

        if (this.props.isSpecial) {
            return (
                <div>
                    <BarcodeAttendance
                        jurorName={this.props.jurorName}
                        jurorID={this.props.jurorID}
                        jurorReportingDateTime={this.props.jurorReportingDateTime}
                        logOut={this.props.logOut}
                        isSpecial={this.props.isSpecial}
                    />
                    <Notifications visible="false" jurorID={this.props.jurorID} />
                </div>
            );
        } else {
            switch (this.props.jurorStatus) {
                case 'questionnaireComplete':
                    return (
                        <div>
                            <BarcodeAttendance
                                jurorName={this.props.jurorName}
                                jurorID={this.props.jurorID}
                                jurorReportingDateTime={this.props.jurorReportingDateTime}
                                logOut={this.props.logOut}
                            />
                            <Notifications visible="false" jurorID={this.props.jurorID} />
                        </div>
                    );

                case 'possibleDeferment':
                    return (
                        <div>
                            <Review
                                jurorName={this.props.jurorName}
                                jurorID={this.props.jurorID}
                                jurorReportingDateTime={this.props.jurorReportingDateTime}
                                logOut={this.props.logOut}
                                affidavitLink={this.state.affidavitLink}
                            />
                            <Notifications visible="false" jurorID={this.props.jurorID} />
                        </div>
                    );

                case 'deferred':
                    return (
                        <DefermentMessage
                            jurorName={this.props.jurorName}
                            jurorID={this.props.jurorID}
                            jurorReportingDateTime={this.props.jurorReportingDateTime}
                            logOut={this.props.logOut}
                        />
                    );

                default:
                    // need to catch for invalid status
                    return (
                        <ErrorMessage
                            jurorName={this.props.jurorName}
                            jurorID={this.props.jurorID}
                            jurorReportingDateTime={this.props.jurorReportingDateTime}
                            logOut={this.props.logOut}
                        />
                    );
            }
        }
    }
}
